import { Component, Input, OnInit } from '@angular/core';
import { Perfil } from '../../shared/interfaces';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
@Component({
    selector: 'nominacion-card',
    templateUrl: './nominacion-card.component.html',
    styleUrl: './nominacion-card.component.scss'
})
export class NominacionCardComponent implements OnInit {

    @Input() perfil: any = {};
    @Input() finalista: boolean = false;
    @Input() ganador: boolean = false;
    private urlBase: string = '';
    constructor(private route: Router) {
        this.urlBase = environment.apiUrl;
    }

    ngOnInit(): void {

    }

    abrirPerfil() {
        this.route.navigate([`perfil/${this.perfil.url_perfil}`])
    }

    urlImagen(url: string) {
        return `${this.urlBase}/uploads/${url}`
    }

}